/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const CANDIDATE_APPLICATION_QUERY_JLP = gql`
  query candidateApplicationQueryJLPNoId {
    candidate {
      applications(limit: 1) {
        collection {
          id
          bearerToken
          folder {
            name
          }
          insights {
            answerSuggestions
            dataSource
          }
          responses(syncPrompts: true) {
            id
            value
            url
            docs
            prompt {
              id
              title
              typeName
              categoryName
              metadata
              documentInstruction
              documentSampleUrl
              documentTag {
                name
                country
                parameters {
                  processable
                  landingPageProcessable
                }
              }
            }
          }
          insights {
            answerSuggestions
            dataSource
          }
        }
      }
    }
  }
`;

export const CANDIDATE_APPLICATION_COMPLETION_QUERY_JLP = gql`
  query candidateApplicationCompletionQueryJLPNoId {
    candidate {
      applications(limit: 1) {
        collection {
          id
          callToActionCompletionMessage
        }
      }
    }
  }
`;

export const CANDIDATE_APPLICATION_EMAIL_PREFERENCE_QUERY_JLP = gql`
  query candidateApplicationEmailPreferenceQueryJLPNoId {
    candidate {
      applications(limit: 1) {
        collection {
          id
          firstName
          lastName
          email
          profileAttributes {
            key
            raw
          }
        }
      }
    }
  }
`;

// Cached by idempotency
export const CANDIDATE_APPLICATION_TALKSCORE_REPORT = gql`
  query candidateApplicationTalkScoreReport {
    candidate {
      applications(limit: 1) {
        collection {
          id
          firstName
          lastName
          fullName
          email
          msisdn
          address {
            city
          }
          profileAttributes {
            key
            raw
          }
          responses {
            id
            value
            url
            others
            createdAt
            prompt {
              id
              title
              categoryName
            }
          }
        }
      }
    }
  }
`;

// NOTE: Not used
export const CANDIDATE_APPLICATION_QUERY = gql`
  query candidateApplicationQuery {
    candidate {
      applications(limit: 1) {
        collection {
          id
          email
          msisdn
          createdAt
          updatedAt
          deletedAt
          firstName
          lastName
          gender
          education
          schoolName
          graduationYear
          lastEmployer
          yearsOfExp
          bearerToken
          address {
            street
            state
            city
            country
            postalCode
            latitude
            longitude
          }
          prompts {
            id
            title
            categoryName
            metadata
            documentInstruction
            documentSampleUrl
          }
          responses {
            id
            value
            url
            prompt {
              id
              title
              categoryName
              metadata
              documentInstruction
              documentSampleUrl
            }
          }
        }
      }
    }
  }
`;
